__turbopack_context__.v({
  "Blob": "_89C1Ra_Blob",
  "ButtonContainer": "_89C1Ra_ButtonContainer",
  "ButtonContainerRichText": "_89C1Ra_ButtonContainerRichText",
  "Content": "_89C1Ra_Content",
  "DateContainer": "_89C1Ra_DateContainer",
  "DateIcon": "_89C1Ra_DateIcon",
  "DateText": "_89C1Ra_DateText",
  "GreenBlue": "_89C1Ra_GreenBlue",
  "HasImage": "_89C1Ra_HasImage",
  "ImageContainer": "_89C1Ra_ImageContainer",
  "ImageVisible": "_89C1Ra_ImageVisible",
  "IsFromRichText": "_89C1Ra_IsFromRichText",
  "Label": "_89C1Ra_Label",
  "LastUpdated": "_89C1Ra_LastUpdated",
  "LocationContainer": "_89C1Ra_LocationContainer",
  "LocationIcon": "_89C1Ra_LocationIcon",
  "LocationText": "_89C1Ra_LocationText",
  "MetaInfo": "_89C1Ra_MetaInfo",
  "PinkBlue": "_89C1Ra_PinkBlue",
  "PinkOrange": "_89C1Ra_PinkOrange",
  "PinkPurple": "_89C1Ra_PinkPurple",
  "RichText": "_89C1Ra_RichText",
  "Root": "_89C1Ra_Root",
  "Text": "_89C1Ra_Text",
  "Title": "_89C1Ra_Title",
  "TitleBottom": "_89C1Ra_TitleBottom",
  "TitleContainer": "_89C1Ra_TitleContainer",
  "TitleDesktop": "_89C1Ra_TitleDesktop",
  "TitleMobile": "_89C1Ra_TitleMobile",
  "TitleTop": "_89C1Ra_TitleTop",
  "Visible": "_89C1Ra_Visible",
});
